import { ModuleNode } from "../types";

// Data Pipeline with submodules (items-only pages)
export const dataPipelineModule: ModuleNode = {
    key: "datapipeline",
    title: "Data Pipeline",
    submodules: [
        {
            key: "dataOps-sustain",
            title: "DataOps Sustain",
            route: "/dashboard/dataOpsLanding",
            pages: [
                {
                    key: "programs-dashboard",
                    title: "Programs Dashboard",
                    route: "/data-pipeline/dataOps",
                    items: [
                        { key: "prgms", label: "Programs", tags: ["programs"] },
                    ],
                },
                {
                    key: "create-program",
                    title: "Create Program",
                    route: "/data-pipeline/programs-tab",
                    items: [
                        { key: "program-tab", label: "Program", tags: ["program", "projects", "create", "Jobs", "Alerts"] },
                    ],
                },
                {
                    key: "executive-template",
                    title: "Executive Template",
                    route: "/data-pipeline/executiveTemplate",
                    items: [
                        { key: "executive-template-setup", label: "Executive Template Setup", tags: ["executive", "template", "setup", "configuration", "contacts"] },
                    ],
                },
            ],
        },
        {
            key: "programops",
            title: "Program Ops Dashboards",
            route: "/data-pipeline/programOpsDashboard",
            submodules: [
                {
                    key: "ibp",
                    title: "IBP",
                    route: "/data-pipeline/programOps/IBP/markets",
                    pages: [
                        {
                            key: "ibp-global",
                            title: "IBP Global",
                            route: "/data-pipeline/programOps/IBP/markets",
                            items: [],
                        },
                        {
                            key: "ibp-poc",
                            title: "IBP Global - React JS POC",
                            route: "/data-pipeline/programOps/IBP/markets/ibp-dashboard",
                            items: [],
                        },
                        {
                            key: "ibp-reactjs",
                            title: "IBP Global ReactJS",
                            route: "/data-pipeline/programOps/IBP/markets/ibpDashboard",
                            items: [],
                        },
                    ],
                },
                {
                    key: "mdip",
                    title: "MDIP",
                    route: "/data-pipeline/programOps/MDIP/list",
                    pages: [
                        {
                            key: "mdip-list",
                            title: "MDIP Dashboards",
                            route: "/data-pipeline/programOps/MDIP/list",
                            items: [],
                        },
                    ],
                },
                {
                    key: "mosaic",
                    title: "Mosaic",
                    route: "/data-pipeline/programOps/Mosaic/list",
                    pages: [
                        {
                            key: "mosaic-list",
                            title: "Mosaic Dashboards",
                            route: "/data-pipeline/programOps/Mosaic/list",
                            items: [],
                        },
                    ],
                },
            ]
        },
        {
            key: "sector-executive-dashboard",
            title: "End to End Observability Dashboard",
            route: "/data-pipeline/home/executiveOps",
            submodules: [
                {
                    key: "sector-dashboards",
                    title: "Sector Dashboards",
                    route: "/data-pipeline/executiveOps",
                    pages: [
                        {
                            key: "sectors",
                            title: "",
                            route: "/data-pipeline/executiveOps",
                            items: [
                                { key: "program", label: "Program", tags: ["program", "pbna", "Bods"] },
                            ],
                        },
                    ],
                },
                {
                    key: "program-dashboards",
                    title: "Program Dashboards",
                    route: "/data-pipeline/executiveOps/apac",
                    pages: [
                        {
                            key: "programs",
                            title: "",
                            route: "/data-pipeline/executiveOps/apac",
                            items: [
                                { key: "program", label: "Program", tags: ["program", "apac", "Bods"] },
                            ],
                        },
                    ],
                },
                {
                    key: "data-recon-dashboards",
                    title: "Data Recon Dashboards",
                    route: "/data-pipeline/executiveOps/pepsellPepIrisRecon",
                    pages: [
                        {
                            key: "programs",
                            title: "",
                            route: "/data-pipeline/executiveOps/pepsellPepIrisRecon",
                            items: [],
                        },
                    ],
                },
            ]
        },
    ],
};
